if (!customElements.get('product-information-tabs')) {
  customElements.define('product-information-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      let group = [];
      const enhance = () => {
        if (group.length < 2) { group = []; return; }
        const list = document.createElement('div');
        list.className = 'product-tabs__list';
        list.setAttribute('role', 'tablist');
        list.setAttribute('aria-label', this.dataset.label);
        group[0].before(list);
        group.forEach((panel, index) => {
          const summary = panel.querySelector('summary');
          const replacement = document.createElement('div');
          [...panel.attributes].forEach(({ name, value }) => {
            if (name !== 'open') replacement.setAttribute(name, value);
          });
          [...panel.childNodes].forEach((node) => { if (node !== summary) replacement.append(node); });
          panel.replaceWith(replacement);
          panel = replacement;
          const button = document.createElement('button');
          panel.id ||= this.id + '-panel-' + this.querySelectorAll('[role="tabpanel"]').length;
          button.id = panel.id + '-tab';
          button.type = 'button';
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', panel.id);
          button.textContent = summary.querySelector('span')?.textContent || summary.textContent;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', button.id);
          panel.tabIndex = 0;
          button.tabIndex = index ? -1 : 0;
          button.setAttribute('aria-selected', String(index === 0));
          panel.hidden = index !== 0;
          list.append(button);
        });
        group = [];
      };
      [...this.children].forEach((child) => {
        if (child.matches('details.product-page__accordion')) group.push(child);
        else enhance();
      });
      enhance();
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.activate(tab);
      });
      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const tabs = [...tab.parentElement.children];
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const step = event.key === 'ArrowRight' ? direction : -direction;
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + step + tabs.length) % tabs.length;
        event.preventDefault();
        this.activate(tabs[index]);
        tabs[index].focus();
      });
      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[role="tabpanel"]');
        const tab = panel && this.querySelector('[aria-controls="' + CSS.escape(panel.id) + '"]');
        if (tab) this.activate(tab);
      });
    }
    activate(tab) {
      [...tab.parentElement.children].forEach((button) => {
        const selected = button === tab;
        button.tabIndex = selected ? 0 : -1;
        button.setAttribute('aria-selected', String(selected));
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
    }
  });
}
